module.exports = __webpack_public_path__ + "teqbahn-assets/media/HumanMachineCollaborationThroughTeqitPlatform.d28c8573.png";